<template>
  <div class="d-flex flex-grow-1 flex-column">
    <div class="p-4">
      <el-container>
        <el-header class="text-center font-bold text-xl">小额贷款公司经营情况简报<el-button :loading="loading" style="float: right;" type="text" @click="handleExport">导出</el-button></el-header>
        <el-main class="leading-8">
          <p class="indent-8" v-for="(content,index) in contents" :key="index">
            {{ content }}
          </p>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import Layout2 from '../../Shared/Layout2'
import axios from 'axios'

export default {
  components: {},
  layout: Layout2,
  middleware: ['auth'],
  metaInfo() {
    return {title: '简报'}
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      contents: []
    }
  },
  watch: {}, mounted() {
  },
  created() {
    this.getData()
  },
  methods: {
    handleExport() {
      this.loading = true
      axios.get('/dashboard/brief_export').then(res => {
        this.loading = false

        if (res.data.status === 1) {
          // this.contents = res.data.contents
          window.open(res.data.url)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getData() {
      axios.get('/dashboard/brief').then(res => {
        if (res.data.status === 1) {
          this.contents = res.data.contents
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
